import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Project } from '../models/project';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectDataService {

  constructor(private http: HttpClient) { }
  getAllProjects = (): Observable<Project[]> => {
    return this.http.get<Project[]>(`${environment.api.baseUrl}/${environment.api.endpoints.project.projectList}`).pipe(
      map(projects => projects && projects.sort((p1, p2) => p1.id < p2.id ? 1 : -1))
    );
  }

}
